var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.useSeconds)?_c('span',{attrs:{"title":_vm.title}},[_vm._v("\n    "+_vm._s(_vm.seconds)+"s\n")]):_c('span',[_vm._v("\n    "+_vm._s(Math.round(_vm.ms))+"ms\n")])}
var staticRenderFns = []

export { render, staticRenderFns }